import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AXFWidgetView } from '../../../config/widget';

@Component({
  selector: '[axf-page-footer]',
  templateUrl: './page-footer-widget.view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { role: 'page-footer' },
})
export class AXFPageFooterWidgetView extends AXFWidgetView {
  constructor() {
    super();
  }
}
